import api from '@/api';
import { BenefitListRequest, BenefitListResponse } from './benefits.types';

const API = '/operational/v1/benefits';

export default {
  async list(params?: BenefitListRequest) {
    const result = (await api.get(API, params)) as unknown;
    return result as BenefitListResponse;
  },
};
